import { render, staticRenderFns } from "./seatsToSuitMobile.vue?vue&type=template&id=2b2db6d9&scoped=true&"
import script from "./seatsToSuitMobile.vue?vue&type=script&lang=js&"
export * from "./seatsToSuitMobile.vue?vue&type=script&lang=js&"
import style0 from "./seatsToSuitMobile.vue?vue&type=style&index=0&id=2b2db6d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2db6d9",
  null
  
)

export default component.exports